// Import model
import { StartEstimateAddLineItemRequest } from '../models/StartEstimateAddLineItemRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartEstimateAddLineItemRequest - handles JSON serialization and deserialization with type validation
 */
export class StartEstimateAddLineItemRequestSerializer {
  /**
   * Deserializes a JSON string into a StartEstimateAddLineItemRequest instance
   */
  static deserialize(json: string): StartEstimateAddLineItemRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartEstimateAddLineItemRequest instance
   */
  static fromObject(obj: any): StartEstimateAddLineItemRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartEstimateAddLineItemRequest');
    }


    const instance: StartEstimateAddLineItemRequest = {
      itemId: obj['itemId'] as string | undefined,
      source: obj['source'] as string | undefined,
      quantity: obj['quantity'] as number | undefined,
      uom: obj['uom'] as string | undefined,
      appliesTo: obj['AppliesTo'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartEstimateAddLineItemRequest instances
   */
  static deserializeArray(json: string): StartEstimateAddLineItemRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartEstimateAddLineItemRequest instance to a JSON string
   */
  static serialize(instance: StartEstimateAddLineItemRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartEstimateAddLineItemRequest instance to a plain object
   */
  static toObject(instance: StartEstimateAddLineItemRequest): any {
    return {
      'itemId': instance.itemId,
      'source': instance.source,
      'quantity': instance.quantity,
      'uom': instance.uom,
      'AppliesTo': instance.appliesTo,
    };
  }

  /**
   * Serializes an array of StartEstimateAddLineItemRequest instances to a JSON string
   */
  static serializeArray(instances: StartEstimateAddLineItemRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
